import type { z } from 'zod';

import { indexSearchSchema, listParams } from '@nucleus-commerce/admin-kit/index-table';

import type { BlogPostListParams } from '../api/blog-api';
import { BLOG_POST_FILTER_FIELDS, BLOG_POST_SORTS } from '../components/blog-post-filters';

/** URL search params of the posts list; mirrors GET /admin/v1/stores/{storeId}/blog/posts. */
export const blogPostListSearchSchema = indexSearchSchema(BLOG_POST_FILTER_FIELDS, {
  sort: BLOG_POST_SORTS,
});

export type BlogPostListSearch = z.infer<typeof blogPostListSearchSchema>;

/** The list request for a validated search; the page's `useSearchListState().params` match it. */
export function blogPostListParams(search: BlogPostListSearch): BlogPostListParams {
  return listParams(search, BLOG_POST_FILTER_FIELDS);
}
